import React from 'react';
import { motion } from 'framer-motion';
export function WhyGoldspeakers() {
  const benefits = ['Documented ROI – from culture shift to performance gain', 'Safe hands on stage – seasoned, credible, and rated top tier', 'Strategic clarity – every talk designed to support your goals', 'Fully supported delivery – we prep and debrief every assignment'];
  return <section className="py-20 bg-cream-50" data-id="element-156">
      <div className="max-w-7xl mx-auto px-6" data-id="element-157">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm border border-cream-200 overflow-hidden" data-id="element-158">
          <div className="p-8 md:p-12" data-id="element-159">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="text-center mb-10" data-id="element-160">
              <h2 className="text-3xl md:text-4xl font-heading text-navy-900 mb-3" data-id="element-161">
                Why Goldspeakers?
              </h2>
              <p className="text-gold-500 font-medium tracking-wide uppercase text-sm" data-id="element-162">
                We Curate. You Deliver Results.
              </p>
            </motion.div>

            <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-163">
              <div data-id="element-164">
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-165">
                  Most speaker bureaus list hundreds of names. We work with a
                  selected few – each chosen for their ability to create lasting
                  change in leadership, culture, and communication.
                </p>
                <h3 className="text-xl font-heading text-navy-900 mb-4" data-id="element-166">
                  What sets our speakers apart:
                </h3>
                <ul className="space-y-3" data-id="element-167">
                  {benefits.map((benefit, index) => <motion.li key={index} initial={{
                  opacity: 0,
                  x: -10
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: index * 0.1
                }} className="flex items-start gap-3" data-id="element-168">
                      <span className="mt-1.5 w-2 h-2 rounded-full bg-gold-500 flex-shrink-0" data-id="element-169" />
                      <span className="text-gray-700" data-id="element-170">{benefit}</span>
                    </motion.li>)}
                </ul>
              </div>

              <div className="relative h-full min-h-[300px] bg-cream-100 rounded-xl overflow-hidden" data-id="element-171">
                {/* Placeholder for an image if we had one, using a subtle pattern/gradient for now */}
                <div className="absolute inset-0 bg-gradient-to-br from-cream-200 to-cream-100 flex items-center justify-center p-8 text-center" data-id="element-172">
                  <div className="bg-white/80 backdrop-blur-sm p-6 rounded-lg shadow-sm" data-id="element-173">
                    <p className="font-heading text-xl text-navy-900 italic" data-id="element-174">
                      "We don't just fill a slot. We help you move the needle."
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}